import { Component, OnInit } from '@angular/core';
import { FetchRolesReportService } from './fetch-roles-report.service';
import { Router } from '@angular/router';
import { Report, RowActions } from '../../../../report/report';

@Component({
  selector: 'app-manage-roles',
  templateUrl: './manage-roles.component.html',
  styleUrls: ['./manage-roles.component.scss']
})
export class ManageRolesComponent implements OnInit {
  tableColumns: string[] = ["id", "name", "type"];

  displayTableColumns = {
    id: "Role Id",
    name: "Role Name",
    type: "Role Type"
  };

  rowActions: RowActions[] = [
    {
      actionName: "edit",
      actionType: "icon",
      iconClass: "fa-edit"
    }
  ];

  totalNumberOfRecords = 0;
  rolesData: any[] = [];

  requestBody: Report = {};
  loading = false;
  constructor(
    public fetchRoles: FetchRolesReportService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.fetchRoles.deactivateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  actionsCB(object: any) {
    this.router.navigate(["/admin/actions/roles/edit/" + object.key.id]);
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchRoles.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.fetchRoles.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchRoles.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchRoles.loader().subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    this.fetchRoles.setParams(this.requestBody);
    const report = await this.fetchRoles.make();
    this.rolesData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }
}
